














































  import { Filter } from '@empathyco/x-types';
  import { mixins } from 'vue-class-component';
  import { Component, Prop } from 'vue-property-decorator';
  import { xComponentMixin, XProvide } from '../../../../components';
  import { VueCSSClasses } from '../../../../utils';
  import { facetsXModule } from '../../x-module';
  import { dynamicPropsMixin } from '../../../../components/dynamic-props.mixin';
  import FiltersInjectionMixin from './filters-injection.mixin';

  /**
   * Component that slices a list of filters and returns them using the default scoped slot,
   * allowing the user to show the full list of them or slicing them again using the
   * show more/less buttons.
   *
   * @public
   */
  @Component({
    mixins: [xComponentMixin(facetsXModule), dynamicPropsMixin(['buttonClass'])]
  })
  export default class SlicedFilters extends mixins(FiltersInjectionMixin) {
    /**
     * The maximum number of filters to show.
     *
     * @public
     */
    @Prop({ required: true })
    protected max!: number;

    /** For showing the remaining filters. */
    public showMoreFilters = true;

    /**
     * Show the buttons template when length filters is greater than property max.
     *
     * @returns Boolean if length filters is greater than property max.
     * @internal
     */
    protected get showButton(): boolean {
      return this.renderedFilters.length > this.max;
    }

    /**
     * Sliced the array of filters depends on click button show more.
     *
     * @returns Array of sliced filters or all filters.
     * @internal
     */
    @XProvide('filters')
    public get slicedFilters(): Filter[] {
      return this.showMoreFilters ? this.renderedFilters.slice(0, this.max) : this.renderedFilters;
    }

    /**
     * The difference between length filters and max to show.
     *
     * @returns Number of remaining filters to show.
     * @internal
     */
    protected get difference(): number {
      return this.renderedFilters.length - this.max;
    }

    /**
     * Show or hide the remaining filters. It also emits a Vue event based on the clicked button.
     *
     * @param event - The click event.
     *
     * @internal
     */
    protected toggleShowMoreFilters(event: MouseEvent): void {
      this.showMoreFilters = !this.showMoreFilters;
      this.$emit(this.showMoreFilters ? 'click:show-less' : 'click:show-more', event);
    }

    /**
     * Adds the dynamic css classes to the component.
     *
     * @returns The classes to be added to the component.
     * @internal
     */
    protected get cssClasses(): VueCSSClasses {
      return {
        'x-sliced-filters--is-sliced': this.showButton
      };
    }
  }
